module.exports = __webpack_public_path__ + "static/media/smoke.674e2529.svg";